import { useQuery } from "@apollo/client";
import version from "enefel/version";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { paths } from "../../path";
import { GET_ME, GET_SERVER_TEST } from "../../query/UserQueries";
import ColUntyped from "../Interface/Col";
import Copyright from "./Copyright";
import Discord from "./Discord";
import Facebook from "./Facebook";
import { Instagram } from "./Instagram";
import { TikTok } from "./TikTok";
import { YouTube } from "./YouTube";
const Col = ColUntyped as any;

const FooterWrapper = styled.div`
  align-items: center;
  color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;

  a {
    color: white;
    margin: 0 0.5em;
  }

  img {
    width: 20px;
    height: 20px;
  }

  & > *:first-child {
    margin-right: 1em;
  }
`;

const LegalLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5em;
  width: 100%;
  padding: 0.4em 0 0.1em;
  font-size: 0.7rem;

  a {
    color: rgba(255, 255, 255, 0.35);
    text-decoration: none;
    &:hover {
      color: rgba(255, 255, 255, 0.65);
    }
  }
`;

const VersionText = styled.div`
  color: rgba(255, 255, 255, 0.3);
  font-size: 0.7rem;
  margin-left: 1em;
`;

const ServerTestText = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.6rem;
  margin-left: 0.5em;
  font-style: italic;
`;

type FooterProps = {};

export const Footer: FC<FooterProps> = () => {
  const { data: meData } = useQuery(GET_ME);
  const { data: serverTestData } = useQuery(GET_SERVER_TEST, {
    skip: !meData?.me?.isAdmin,
  });

  const isAdmin = meData?.me?.isAdmin;
  const serverVersion = serverTestData?.serverTest;
  const { t } = useTranslation();

  return (
    <Col withBorder={false}>
      <FooterWrapper>
        <Copyright />
        <Facebook />
        <TikTok />
        <YouTube />
        <Instagram />
        <Discord />
        <VersionText>v{version}</VersionText>
        {isAdmin && serverVersion && (
          <ServerTestText>server: {serverVersion}</ServerTestText>
        )}
      </FooterWrapper>
      <LegalLinks>
        <Link to={paths.discover}>{t("discover:nav_link")}</Link>
        <Link to={paths.rules}>{t("gameRules:nav_link")}</Link>
        <Link to={paths.legalNotices}>{t("legal:footer_notices")}</Link>
        <Link to={paths.termsOfUse}>{t("legal:footer_cgu")}</Link>
        <Link to={paths.termsOfSale}>{t("legal:footer_cgv")}</Link>
        <Link to={paths.privacy}>{t("legal:footer_privacy")}</Link>
      </LegalLinks>

    </Col>
  );
};
